(() => {
  if (window.__codexContactQrReady) return;
  window.__codexContactQrReady = true;

  const mobileQuery = window.matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)');

  function isMobileIntent() {
    return mobileQuery.matches;
  }

  function injectPolishStyles() {
    if (document.getElementById('codex-product-polish-styles')) return;
    const style = document.createElement('style');
    style.id = 'codex-product-polish-styles';
    style.textContent = `
      #MainContent .codex-rating-row {
        display: none !important;
      }

      #MainContent product-info .product__info-container {
        display: flex !important;
        flex-direction: column !important;
      }

      #MainContent product-info .product__info-container > * {
        order: 50;
      }

      #MainContent product-info .product__info-container > .product__text,
      #MainContent product-info .product__info-container > p.product__text {
        order: 10 !important;
      }

      #MainContent product-info .product__info-container > .product__title {
        order: 20 !important;
      }

      #MainContent product-info .product__info-container > [id^='price-'] {
        order: 40 !important;
      }

      #MainContent .related-products__heading {
        max-width: 1320px !important;
        margin: 0 auto 34px !important;
        text-align: left !important;
        color: var(--codex-ink, #101828) !important;
        font-family: 'Cormorant Garamond', Georgia, serif !important;
        font-size: clamp(30px, 3.1vw, 42px) !important;
        line-height: 1.05 !important;
        font-weight: 600 !important;
        letter-spacing: 0 !important;
      }

      #MainContent product-recommendations.related-products .card-information,
      #MainContent product-recommendations.related-products .price,
      #MainContent product-recommendations.related-products .price * {
        font-family: var(--font-body-family, 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif) !important;
      }

      #MainContent product-recommendations.related-products .price {
        margin-top: 14px !important;
        color: #111827 !important;
        font-size: clamp(18px, 1.25vw, 22px) !important;
        font-weight: 400 !important;
        line-height: 1.32 !important;
        letter-spacing: 0.015em !important;
      }

      #MainContent product-recommendations.related-products .price .price-item,
      #MainContent product-recommendations.related-products .price__regular,
      #MainContent product-recommendations.related-products .price__sale,
      #MainContent product-recommendations.related-products .price__container {
        color: inherit !important;
        font-size: inherit !important;
        font-weight: inherit !important;
        line-height: inherit !important;
        letter-spacing: inherit !important;
      }

      #MainContent product-recommendations.related-products .price--on-sale .price-item--regular,
      #MainContent product-recommendations.related-products .price__compare,
      #MainContent product-recommendations.related-products s.price-item {
        color: #4b5563 !important;
        font-size: clamp(14px, 0.9vw, 16px) !important;
        font-weight: 400 !important;
        text-decoration-thickness: 1px !important;
        text-decoration-color: currentColor !important;
      }

      #MainContent product-recommendations.related-products .card__heading,
      #MainContent product-recommendations.related-products .card__heading a {
        font-family: 'Cormorant Garamond', Georgia, serif !important;
        font-weight: 600 !important;
      }

      #MainContent .codex-selected-price-row.is-custom-quote {
        display: flex !important;
        min-height: auto !important;
        flex-direction: column !important;
        align-items: flex-start !important;
        justify-content: center !important;
        gap: 7px !important;
        padding: 16px 20px !important;
      }

      #MainContent .codex-selected-price-row.is-custom-quote .codex-selected-price-label {
        max-width: none !important;
        width: 100% !important;
        white-space: normal !important;
      }

      #MainContent .codex-selected-price-row.is-custom-quote .codex-selected-price-value {
        width: 100% !important;
        justify-self: auto !important;
        text-align: left !important;
      }

      #MainContent .codex-selected-price-row.is-custom-quote .codex-price-custom-copy {
        display: block !important;
        max-width: 100% !important;
        color: var(--codex-ink) !important;
        font-family: 'Cormorant Garamond', Georgia, serif !important;
        font-size: clamp(22px, 2.2vw, 27px) !important;
        line-height: 1.08 !important;
        white-space: normal !important;
      }

      @media screen and (max-width: 749px) {
        #MainContent .related-products__heading {
          font-size: 32px !important;
          margin-bottom: 24px !important;
        }

        #MainContent product-recommendations.related-products .price {
          font-size: 18px !important;
          margin-top: 10px !important;
        }

        #MainContent .codex-selected-price-row.is-custom-quote {
          padding: 14px 16px !important;
        }

        #MainContent .codex-selected-price-row.is-custom-quote .codex-price-custom-copy {
          font-size: 22px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', 'hidden');
    modal.classList.remove('is-whatsapp', 'is-messenger');
    document.documentElement.classList.remove('codex-qr-open');
  }

  function openModal(trigger) {
    const container = trigger.closest('.codex-custom-cta') || document;
    const modal = container.querySelector('[data-codex-qr-modal]') || document.querySelector('[data-codex-qr-modal]');
    if (!modal) return;

    const channel = trigger.getAttribute('data-codex-channel') || 'contact';
    const title = trigger.getAttribute('data-qr-title') || trigger.textContent.trim();
    const qrSrc = trigger.getAttribute('data-qr-src');
    const directUrl = trigger.getAttribute('data-mobile-url') || trigger.href;
    const icon = trigger.querySelector('.codex-contact-icon')?.innerHTML || '';

    modal.classList.remove('is-whatsapp', 'is-messenger');
    modal.classList.add(`is-${channel}`);

    const titleNode = modal.querySelector('[data-codex-qr-title]');
    const imageNode = modal.querySelector('[data-codex-qr-image]');
    const logoNode = modal.querySelector('[data-codex-qr-logo]');
    const openLink = modal.querySelector('[data-codex-qr-link]');

    if (titleNode) titleNode.textContent = title;
    if (imageNode && qrSrc) {
      imageNode.src = qrSrc;
      imageNode.alt = `${title} QR code`;
    }
    if (logoNode) logoNode.innerHTML = icon;
    if (openLink) {
      openLink.href = directUrl;
      openLink.textContent = `Open ${title}`;
    }

    modal.removeAttribute('hidden');
    document.documentElement.classList.add('codex-qr-open');
    modal.querySelector('[data-codex-qr-close]')?.focus({ preventScroll: true });
  }

  function fallbackCopy(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', 'readonly');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
    } catch (error) {
      console.warn('Copy failed', error);
    }
    textarea.remove();
  }

  async function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    fallbackCopy(text);
  }

  function showCopiedFeedback(trigger, email) {
    const hint = trigger.querySelector('.codex-contact-hint');
    const original = hint?.dataset.originalText || hint?.textContent || '';
    if (hint && !hint.dataset.originalText) hint.dataset.originalText = original;

    trigger.classList.add('is-copied');
    if (hint) hint.textContent = 'Email copied';
    trigger.setAttribute('aria-label', `Email copied: ${email}`);

    window.clearTimeout(trigger.__codexCopyTimer);
    trigger.__codexCopyTimer = window.setTimeout(() => {
      trigger.classList.remove('is-copied');
      if (hint) hint.textContent = hint.dataset.originalText || original;
      trigger.setAttribute('aria-label', 'Email Forever For Love');
    }, 1800);
  }

  function extractEmail(trigger) {
    const href = trigger.getAttribute('href') || '';
    const mailto = href.match(/^mailto:([^?]+)/i);
    return decodeURIComponent(mailto?.[1] || trigger.dataset.copyEmail || '').trim();
  }

  injectPolishStyles();

  document.addEventListener('shopify:section:load', injectPolishStyles);

  document.addEventListener('click', (event) => {
    const closeTarget = event.target.closest('[data-codex-qr-close]');
    if (closeTarget) {
      event.preventDefault();
      closeModal(closeTarget.closest('[data-codex-qr-modal]'));
      return;
    }

    const emailTrigger = event.target.closest('.codex-email');
    if (emailTrigger && (emailTrigger.getAttribute('href') || '').toLowerCase().startsWith('mailto:')) {
      const email = extractEmail(emailTrigger);
      if (email) {
        event.preventDefault();
        copyText(email).catch(() => fallbackCopy(email)).finally(() => {
          showCopiedFeedback(emailTrigger, email);
          window.setTimeout(() => {
            window.location.href = emailTrigger.href;
          }, 240);
        });
      }
      return;
    }

    const trigger = event.target.closest('[data-codex-qr-trigger]');
    if (!trigger) return;
    if (isMobileIntent()) return;

    event.preventDefault();
    openModal(trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-codex-qr-modal]:not([hidden])').forEach(closeModal);
  });
})();

(() => {
  if (window.__fflAvailableCaratScaleReady) return;
  window.__fflAvailableCaratScaleReady = true;

  function isDisabledRadio(radio) {
    return !radio || radio.disabled || radio.classList.contains('disabled') || radio.getAttribute('aria-disabled') === 'true';
  }

  function cleanNumber(value) {
    const number = parseFloat(value);
    if (!Number.isFinite(number)) return String(value || '').trim();
    return Number.isInteger(number) ? String(number) : String(number).replace(/0+$/, '').replace(/\.$/, '');
  }

  function compactRange(values) {
    const nums = values.map((value) => parseFloat(value)).filter(Number.isFinite).sort((a, b) => a - b);
    if (!nums.length) return '';
    const whole = nums.filter((value) => Number.isInteger(value));
    if (whole.length >= 2) {
      return `${cleanNumber(whole[0])}-${cleanNumber(whole[whole.length - 1])} ct`;
    }
    if (nums.length === 1) return `${cleanNumber(nums[0])} ct`;
    return `${cleanNumber(nums[0])}-${cleanNumber(nums[nums.length - 1])} ct`;
  }

  function rebuildCaratSlider(fieldset) {
    const wrap = fieldset.querySelector('.ffl-cs');
    const oldRange = fieldset.querySelector('.ffl-cs-range');
    const bubble = fieldset.querySelector('.ffl-cs-bubble');
    const main = fieldset.querySelector('.ffl-cs-main');
    const ticks = fieldset.querySelector('.ffl-cs-ticks');
    if (!wrap || !oldRange || !bubble || !main || wrap.dataset.availableScaleReady === 'true') return;

    const radios = [...fieldset.querySelectorAll('input[type="radio"]')].sort((a, b) => parseFloat(a.value) - parseFloat(b.value));
    const available = radios.filter((radio) => !isDisabledRadio(radio));
    const unavailable = radios.filter(isDisabledRadio);
    if (available.length < 2) return;

    wrap.dataset.availableScaleReady = 'true';

    const range = oldRange.cloneNode(true);
    oldRange.replaceWith(range);
    const buttons = [...wrap.querySelectorAll('.ffl-cs-btn')].map((button) => {
      const clone = button.cloneNode(true);
      button.replaceWith(clone);
      return clone;
    });
    const dec = buttons[0];
    const inc = buttons[1];

    range.min = '0';
    range.max = String(available.length - 1);
    range.step = '1';
    range.setAttribute('aria-valuemin', '0');
    range.setAttribute('aria-valuemax', String(available.length - 1));

    function selectedIndex() {
      const checked = available.findIndex((radio) => radio.checked);
      if (checked >= 0) return checked;
      const anyChecked = radios.find((radio) => radio.checked);
      if (!anyChecked) return 0;
      const checkedValue = parseFloat(anyChecked.value);
      let nearest = 0;
      let distance = Infinity;
      available.forEach((radio, index) => {
        const nextDistance = Math.abs(parseFloat(radio.value) - checkedValue);
        if (nextDistance < distance) {
          distance = nextDistance;
          nearest = index;
        }
      });
      return nearest;
    }

    function paint(index) {
      const clamped = Math.max(0, Math.min(available.length - 1, Number(index) || 0));
      const radio = available[clamped];
      const fraction = available.length > 1 ? clamped / (available.length - 1) : 0;
      const left = `calc(7px + (100% - 14px) * ${fraction})`;
      range.value = String(clamped);
      range.setAttribute('aria-valuenow', String(clamped));
      range.setAttribute('aria-valuetext', `${cleanNumber(radio.value)} ct`);
      bubble.textContent = `${cleanNumber(radio.value)} ct`;
      bubble.style.left = left;
      range.style.background = `linear-gradient(90deg, #4a6fb3 0%, #4a6fb3 ${fraction * 100}%, rgba(74, 111, 179, 0.22) ${fraction * 100}%, rgba(74, 111, 179, 0.22) 100%)`;
      if (dec) dec.disabled = clamped === 0;
      if (inc) inc.disabled = clamped === available.length - 1;
    }

    function commit(index) {
      const clamped = Math.max(0, Math.min(available.length - 1, Number(index) || 0));
      const radio = available[clamped];
      paint(clamped);
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (ticks) {
      ticks.innerHTML = '';
      radios.forEach((radio) => {
        const tick = document.createElement('span');
        tick.className = `ffl-cs-tick${isDisabledRadio(radio) ? ' is-unavailable' : ''}`;
        tick.textContent = cleanNumber(radio.value);
        tick.setAttribute('aria-hidden', 'true');
        ticks.appendChild(tick);
      });
    }

    const highUnavailable = unavailable.filter((radio) => parseFloat(radio.value) > parseFloat(available[available.length - 1].value));
    let note = fieldset.querySelector('.ffl-cs-unavailable-note');
    if (highUnavailable.length) {
      if (!note) {
        note = document.createElement('p');
        note.className = 'ffl-cs-unavailable-note';
        wrap.appendChild(note);
      }
      note.textContent = `${compactRange(highUnavailable.map((radio) => radio.value))} currently unavailable. Contact us for a custom quote.`;
    } else if (note) {
      note.remove();
    }

    range.addEventListener('input', () => paint(range.value));
    range.addEventListener('change', () => commit(range.value));
    if (dec) dec.addEventListener('click', () => commit(Number(range.value) - 1));
    if (inc) inc.addEventListener('click', () => commit(Number(range.value) + 1));
    fieldset.addEventListener('change', (event) => {
      if (event.target && event.target.matches('input[type="radio"]')) {
        window.setTimeout(() => paint(selectedIndex()), 0);
      }
    });

    paint(selectedIndex());
  }

  function initAvailableCaratScales() {
    document.querySelectorAll('.ffl-cs-on').forEach(rebuildCaratSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAvailableCaratScales);
  } else {
    initAvailableCaratScales();
  }
  document.addEventListener('shopify:section:load', initAvailableCaratScales);
})();
